module.exports = __webpack_public_path__ + "img/flor2.46197b8d.svg";